<div class="menu">
  @if (isVisible() === false) {
    <button
      (click)="openMenu()"
      class="menu-button">
      <img alt="menu icon" src="assets/img/icon/mobile-menu.svg" />
    </button>
  }
  @if (isVisible()) {
    <button
      (click)="hideMenu()"
      class="menu-button button--flattened">
      <mat-icon
        aria-hidden="false"
        aria-label="close dialog"
        class="close-button"
        color="primary">
        close
      </mat-icon>
    </button>
  }
</div>
<nav
  #navigationBlock
  [ngClass]="{ 'menu-nav': true, visible: isVisible() }">
  <div class="menu-content">
    <div class="menu-top-section">
      <ul class="nav-list">
        @for (navItem of navigation(); track navItem.url) {
          <li
            [matRippleCentered]="true"
            class="nav-item"
            matRipple>
            @if (navItem.newTab) {
              <a
                (click)="openInNewTab(navItem)"
                [href]="navItem.url"
                target="_blank"
                rel="noopener"
                class="nav-link">
                <img [src]="navItem.icon" class="nav-link-icon" />
                <span class="nav-link-text margin-left-16">{{
                  navItem.title | translate
                }}</span>
              </a>
            }
            @if (!navItem.newTab) {
              <a
                (click)="hideMenu()"
                [routerLink]="navItem.url"
                class="nav-link">
                <img [src]="navItem.icon" class="nav-link-icon" />
                <span class="nav-link-text margin-left-16">{{
                  navItem.title | translate
                }}</span>
                @if (navItem.badge) {
                  <div class="nav-link-badge">
                    <span>{{ navItem.badge }}</span>
                  </div>
                }
              </a>
            }
          </li>
        }
      </ul>
    </div>
    <div class="menu-footer">
      <div class="copyright">
        ©2025 Lidoma Vision Esports Limited, All rights reserved.
      </div>
      <!--            <app-language-selector></app-language-selector>-->
    </div>
  </div>
</nav>
